import { render, staticRenderFns } from "./profit-report-tool.vue?vue&type=template&id=067f1794&scoped=true&"
import script from "./profit-report-tool.vue?vue&type=script&lang=js&"
export * from "./profit-report-tool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f1794",
  null
  
)

export default component.exports